module.exports = __webpack_public_path__ + "static/img/14.583ae46e.jpeg";